import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './TextareaControl.module.scss';

const propTypes = {
  error: PropTypes.string,
  label: PropTypes.node,
};

const defaultProps = {
  error: null,
  label: null,
};

const TextareaControl = ({ error, label, ...inputProps }) => (
  <label>
    {label && <div className={styles.label}>{label}</div>}
    <textarea
      className={classNames(styles.input, { [styles.error]: error })}
      {...inputProps}
    />
  </label>
);

TextareaControl.propTypes = propTypes;
TextareaControl.defaultProps = defaultProps;

export default TextareaControl;
